import React from 'react';
import './SitePage.css';

interface SecretPasswordPageState {
  password: string;
}

class SecretPasswordPage extends React.Component<{}, SecretPasswordPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      password: ''
    }
  }

  onKeyDown(e:any): void {
    if (e.key === 'Enter') {
      window.localStorage.setItem('SecretPassword', this.state.password);
      window.location.reload();
    }
  };

  render() {
    return (
      <div style={{textAlign:'center'}}>
        <br/><br/><br/>
        <input 
          value={this.state.password} 
          onChange={(e:any)=>this.setState({password: e.currentTarget.value})}
          onKeyDown={(e:any)=>this.onKeyDown(e)}
        />
      </div>
    )
  }
}

export default SecretPasswordPage;